import api from "./apiClient";

const endpoint = "alerts";

export const getAllAlerts = () => {
	return api.get(endpoint);
};

export const getValidAlerts = () => {
	return api.get(endpoint + "/valid");
};

export const getAlertById = (id) => {
	return api.get(`${endpoint}/${id}`);
};

export const deleteAlert = (id) => {
	return api.delete(`${endpoint}/${id}`);
};

export const updateAlert = (alert) => {
	return api.put(`${endpoint}/${alert.id}`, alert);
};

export const createAlert = (alert) => {
	return api.post(endpoint, alert);
};

export const downloadAlertImage = async (id) => {
	return api.get(
		`${endpoint}/${id}/image`,
		{},
		{
			responseType: "arraybuffer",
		}
	);
};
